import { Input, SelectV2, Text } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { TransactionRefundState } from './TransactionRefund.state';

const REFUND_REASONS = [
  { key: 'Returned Goods', value: 'Returned Goods' },
  { key: 'Accidental Charge', value: 'Accidental Charge' },
  { key: 'Cancelled Order', value: 'Cancelled Order' },
  { key: 'Other', value: 'Other' },
];

function RefundReason() {
  const { handleChangeOtherReason, handleChangeReason } = TransactionRefundState;
  const { reasonForRefund, otherReasonForRefund } = useSnapshot(TransactionRefundState);

  return (
    <div className="mb-4">
      <Text weight="bold" className="mb-2">
        Reason for Refund
      </Text>
      <div className="md:grid md:grid-cols-[224px_1fr] md:gap-2">
        <SelectV2 side="top" options={REFUND_REASONS} value={reasonForRefund} onChange={handleChangeReason} className="mb-2" />
        {reasonForRefund === 'Other' && (
          <Input type="text" placeholder="Reason for refund" value={otherReasonForRefund} onChangeValue={handleChangeOtherReason} />
        )}
      </div>
    </div>
  );
}

export { RefundReason };
